import { IdentityPerson } from '@reg/shared/model';

/**
 * A single team contact (coach or result email)
 */
export class TeamContact {
    public static TYPE_COACH: string = 'coach';
    public static TYPE_RESULT_EMAIL: string = 'result-email';

    public id: string = null;
    public eventId: string = null;
    public teamId: string = null;
    public identityPersonId: string = null;
    public contactType: string = null;

    private _firstName: string = null;
    set firstName(firstName: string) {
        this._firstName = firstName && firstName.trim();
    }

    get firstName(): string {
        return this._firstName;
    }

    private _lastName: string = null;
    set lastName(lastName: string) {
        this._lastName = lastName && lastName.trim();
    }

    get lastName(): string {
        return this._lastName;
    }

    private _title: string = null;
    set title(title: string) {
        this._title = title && title.trim();
    }

    get title(): string {
        return this._title;
    }

    private _email: string = null;
    set email(email: string) {
        this._email = email && email.trim();
    }

    get email(): string {
        return this._email;
    }

    public formatNameFirstLast(): string {
        let name: string = this.firstName || '';

        if (this.lastName) {
            name += name ? ' ' : '';
            name += this.lastName;
        }

        return name;
    }

    /**
     * Clone TeamContact object
     */
    public clone(): TeamContact {
        const clone: TeamContact = new TeamContact();
        clone.id = this.id;
        clone.teamId = this.teamId;
        clone.eventId = this.eventId;
        clone.firstName = this.firstName;
        clone.lastName = this.lastName;
        clone.email = this.email;
        clone.title = this.title;
        clone.contactType = this.contactType;
        clone.identityPersonId = this.identityPersonId;
        return clone;
    }

    public fillFromIdentityPerson(identityPerson: IdentityPerson): TeamContact {
        this.firstName = identityPerson.firstName;
        this.lastName = identityPerson.lastName;
        this.email = identityPerson.email;
        this.identityPersonId = identityPerson.id;
        this.contactType = TeamContact.TYPE_COACH;
        return this;
    }

    /**
     * Serialize from a json api format
     */
    public serialize(): string {
        const json: any = {};
        json.data = {};
        json.data.type = 'teamContact';
        json.data.id = this.id;
        json.data.attributes = {};
        json.data.attributes.firstName = this.firstName;
        json.data.attributes.lastName = this.lastName;
        json.data.attributes.email = this.email;
        json.data.attributes.title = this.title;
        json.data.attributes.contactType = this.contactType;
        json.data.attributes.identityPersonGuid = this.identityPersonId;
        return JSON.stringify(json);
    }

    /**
     * Deserialize to json api format
     */
    public deserialize(json: any): TeamContact {
        const data: any = json.data || json;
        const attrs: any = data.attributes || {};

        this.id = data.id;
        this.firstName = attrs.firstName;
        this.lastName = attrs.lastName;
        this.email = attrs.email;
        this.title = attrs.title;
        this.eventId = attrs.eventId;
        this.teamId = attrs.teamId;
        this.identityPersonId = attrs.identityPersonId;
        this.contactType = attrs.contactType;

        return this;
    }
}
